<main id="main-content" class="main-content">
  <h2 class="form-header">4. Summary of Analysis</h2>

  <mat-card style="margin-bottom: 24px;">
    <div class="text-div">
      <b>Introduction/Background</b>
      <br>
        <span class="gray-text">Provide a brief introduction and/or background of the fire.</span>
      </div>
      <div class="text" [innerHTML]="customATOB(this.report().background || '--')"></div>

      <!-- Rich Text input -->
    </mat-card>

    @if (this.report().report_type != 'No Treatment' && this.report().report_type != 'Pre-assessment Request') {
      <mat-card style="margin-bottom: 24px;"
        >
        <div class="sub-title">
          Critical Values, Risks, Threats & Resources
        </div>
        <div class="border-div"></div>
        <div class="text-div" style="margin-top: 15px; margin-bottom: 5px;"><b>Critical Values and Threats - Risk
        Assessment:</b></div>
        <p style="max-width: 1000px; padding-left: 16px;">Critical Values were identified during the BAER assessment
          with potential to be at risk from post-fire
          threats. Narrative descriptions of the risk assessments are included here along with a link to the specific
          determinations as documented in the Critical Value spreadsheet. The BAER team evaluated the risk to critical
          values following the risk assessment guidance provided in Forest Service Manual 2523 and guidance papers.
        </p>
        <div class="text-div" style="margin-bottom: 5px;"><b>Critical Value Matrix</b></div>
        @if (!forPDF()) {
          <mat-grid-list cols="4" rowHeight="62px" gutterSize="0">
            <mat-grid-tile colspan="1" rowspan="1" class="matrix-header">Probability of Damage or Loss</mat-grid-tile>
            <mat-grid-tile colspan="3" rowspan="1" class="matrix-header" style="margin: 0;">
              <mat-grid-list cols="3" rowHeight="30px" class="matrix-sub-table">
                <mat-grid-tile colspan="3" rowspan="1" class="matrix-header no-border"
                  style="margin-top: 10px;">Magnitude of Consequences /
                Risk</mat-grid-tile>
                <mat-grid-tile colspan="1" rowspan="1" class="matrix-header no-border"
                style="margin-top: 10px;">Major</mat-grid-tile>
                <mat-grid-tile colspan="1" rowspan="1" class="matrix-header no-border"
                style="margin-top: 10px;">Moderate</mat-grid-tile>
                <mat-grid-tile colspan="1" rowspan="1" class="matrix-header no-border"
                style="margin-top: 10px;">Minor</mat-grid-tile>
              </mat-grid-list>
            </mat-grid-tile>
            <mat-grid-tile colspan="1" rowspan="1">Very Likely</mat-grid-tile>
            <mat-grid-tile colspan="1" rowspan="1" class="matrix-red">Very High</mat-grid-tile>
            <mat-grid-tile colspan="1" rowspan="1" class="matrix-red">Very High</mat-grid-tile>
            <mat-grid-tile colspan="1" rowspan="1">Low</mat-grid-tile>
            <mat-grid-tile colspan="1" rowspan="1">Likely</mat-grid-tile>
            <mat-grid-tile colspan="1" rowspan="1" class="matrix-red">Very High</mat-grid-tile>
            <mat-grid-tile colspan="1" rowspan="1" class="matrix-red">High</mat-grid-tile>
            <mat-grid-tile colspan="1" rowspan="1">Low</mat-grid-tile>
            <mat-grid-tile colspan="1" rowspan="1">Possible</mat-grid-tile>
            <mat-grid-tile colspan="1" rowspan="1" class="matrix-red">High</mat-grid-tile>
            <mat-grid-tile colspan="1" rowspan="1" class="matrix-yellow">Intermediate</mat-grid-tile>
            <mat-grid-tile colspan="1" rowspan="1">Low</mat-grid-tile>
            <mat-grid-tile colspan="1" rowspan="1" class="bottom-border">Unlikely</mat-grid-tile>
            <mat-grid-tile colspan="1" rowspan="1" class="bottom-border matrix-yellow">Intermediate</mat-grid-tile>
            <mat-grid-tile colspan="1" rowspan="1" class="bottom-border">Low</mat-grid-tile>
            <mat-grid-tile colspan="1" rowspan="1" class="bottom-border">Very Low</mat-grid-tile>
          </mat-grid-list>
        }
        @if (forPDF()) {
          <div>
            <img  style="max-width: 700px;" [src]="matriximg" alt="Critical Value Matrix">
          </div>
        }
        <ng-container *ngTemplateOutlet="boxLink"></ng-container>
        @if (report().critical_values) {
          <div class="border-div"></div>
        }
        <div class="text-div" style="padding-top: 16px;">
          <b>Critical Values Highlights Summary</b>
          <br><br>
          <span class="gray-text">
            Describe Critical Values/Resources and Threats. Provide a brief narrative summary of the critical values
            (life, safety, property, natural and cultural resources) and risk ratings, providing a rationale for the
            risk determinations.
            <br><br>
            When the Burned Area Emergency Response (BAER) team determines that emergency treatments are not
            necessary, summarize the rationale and the watershed conditions which led to this conclusion.
          </span>
        </div>
        <div class="text-div">
          <b>Human Life and Safety</b>
        </div>
        <div class="text" [innerHTML]="customATOB(this.report().threats_human || '--')"></div>
        <view-image [supporting_files]="report().supporting_files" section="4" question="human_life"></view-image>
        <div class="text-div">
          <b>Property</b>
        </div>
        <div class="text" [innerHTML]="customATOB(this.report().threatsproperty || '--')"></div>
        <view-image [supporting_files]="report().supporting_files" section="4" question="property"></view-image>
        <div class="text-div">
          <b>Natural Resources</b>
        </div>
        <div class="text" [innerHTML]="customATOB(this.report().threats_natural || '--')"></div>
        <view-image [supporting_files]="report().supporting_files" section="4" question="natural_res"></view-image>
        <div class="text-div">
          <b>Cultural and Heritage Resources</b>
        </div>
        <div class="text" [innerHTML]="customATOB(this.report().threats_cultural || '--')"></div>
        <view-image [supporting_files]="report().supporting_files" section="4" question="cultural_res"></view-image>
      </mat-card>
    }

    @if (this.report().report_type != 'No Treatment' && this.report().report_type != 'Pre-assessment Request') {
      <mat-card style="padding-bottom: 24px;"
        >
        <div class="text-div" id="probability-of-completing-treatment-prior-to-damaging-storm-or-event-heading">
          <b>Probability of Completing Treatment Prior to Damaging Storm or Event</b>
          <br>
            <span class="gray-text">
              Probability of completion prior to the first major storm event. Estimated to the nearest 10 percent.
            </span>
          </div>
          <!-- TABLE Ownership -->
          <div class="table-container">
            <table aria-labelledby="probability-of-completing-treatment-prior-to-damaging-storm-or-event-heading probability-of-completing-treatment-prior-to-damaging-storm-or-event-caption">
              <caption id="probability-of-completing-treatment-prior-to-damaging-storm-or-event-caption" class="usa-sr-only">
                Probability of Completing Treatment Prior to Damaging Storm or Event.
              </caption>transportation-system
              <tr class="table-header">
                <th>Treatment Type</th>
                <th class="right">Probability</th>
              </tr>
              <tr class="table-row">
                <td class="text-cell">Land</td>
                <td class="text-cell right">
                  {{ this.report().treat_prob_land ?? "--" }}%
                </td>
              </tr>
              <tr class="table-row">
                <td class="text-cell">Channel</td>
                <td class="text-cell right">
                  {{ this.report().treat_prob_channel ?? "--" }}%
                </td>
              </tr>
              <tr class="table-row">
                <td class="text-cell">Roads</td>
                <td class="text-cell right">
                  {{ this.report().treat_prob_roads ?? "--" }}%
                </td>
              </tr>
              <tr class="table-row">
                <td class="text-cell">Trails</td>
                <td class="text-cell right">
                  {{ this.report().treat_prob_trails ?? "--" }}%
                </td>
              </tr>
              <tr class="table-row">
                <td class="text-cell">Protection Safety</td>
                <td class="text-cell right">
                  {{ this.report().treat_prob_safety ?? "--" }}%
                </td>
              </tr>
            </table>
          </div>
          <div class="text-div">
            <b>Cost of No-Action (Including Loss)</b>
            <br>
              <span class="gray-text">Enter the cost of the no-action or baseline alternative as calculated using an
              appropriate cost-benefit analysis tool.</span>
            </div>
            <div class="text" [innerHTML]="customATOB(this.report().cost_no_action || '--')"></div>
            <div class="text-div">
              <b>Cost of Selected Alternative (Including Loss)</b>
              <br>
                <span class="gray-text">Enter the cost of the selected alternative as calculated using an appropriate
                cost-benefit analysis tool.</span>
              </div>
              <div class="text" [innerHTML]="customATOB(this.report().cost_alternative || '--')"></div>
            </mat-card>
          }
        </main>

        <ng-template #boxLink>
          @if (report().critical_values) {
            <div class="box-link-container">
              <fa-icon [icon]="faFile" class="faFile" aria-label="link"></fa-icon>
              <div class="support-text">
                <div>
                  Critical Values Risk Matrix
                </div>
                <div class="box-link">
                  <a class="standard-text bold" [href]="decodeURI(report().critical_values)" target="_blank">
                    <fa-icon [icon]="faExternalLink" class="fa-regular link-icon" aria-label="Open Link"></fa-icon>
                    Open file in Box
                  </a>
                </div>
              </div>
            </div>
          }
        </ng-template>
